// extracted by mini-css-extract-plugin
export default {"main":"styles_main__laFxB","container":"styles_container__xYzzc","svgTop":"styles_svgTop__a+8BO","svgBottom":"styles_svgBottom__dC9LL"};